<template>
    <div class="sync-page">
        <back url="/mng/weworkAccount/index" :is-router="true">企业微信账号</back>
        <sync-rule v-if="isEdit" ref="syncRule" :is-edit="true"></sync-rule>
        <sync-set v-else ref="syncSet"></sync-set>
        <div class="sync-page-btn-box" :class="isEdit ? '' : 'sync-page-btn-box-add'">
            <v-button v-if="isEdit" status="primary" @click="updateSyncRule">保存</v-button>
            <v-button v-else status="primary" @click="addSyncConfig">开启</v-button>
            <v-button status="default" class="sync-page-btn" @click="goBackPage">取消</v-button>
        </div>
        <sync-save ref="syncSave"></sync-save>
    </div>
</template>

<script>
import Back from '@/components/back';
import SyncSet from '../../sync-set';
import SyncRule from '../../sync-rule';
import SyncSave from '../../sync-save';

export default {
    components: {
        Back,
        SyncSet,
        SyncRule,
        SyncSave
    },

    data() {
        const isEdit = this.$route.params.type === 'edit';

        return {
            isEdit,
            reqData: {},
            comfirmVisible: false,
            confirmPromiseResolve() {}
        };
    },

    computed: {
        syncMode() {
            return this.reqData && this.reqData.sync_mode;
        }
    },

    methods: {
        addSyncConfig() {
            if (this.$refs.syncSet.validate()) {
                const reqData = this.$refs.syncSet.getData();
                this.$refs.syncSave.addSyncConfig({ reqData }).then(() => {
                    this.goBackPage();
                });
            }
        },

        updateSyncRule() {
            if (this.$refs.syncRule.validate()) {
                const reqData = this.$refs.syncRule.getData();
                this.$refs.syncSave.updateSyncRule({ reqData }).then(() => {
                    this.goBackPage();
                });
            }
        },

        goBackPage() {
            this.$router.push('/mng/weworkAccount/index');
        }
    }
};
</script>
<style lang="less" scoped>
@import './sync-page.less';
</style>
